import { Injectable } from "@angular/core";
import { DataService } from "../DataService/data.service";
import { Observable } from "rxjs";
import { APIName } from "../../Models/APIEndPoints/APIName";
import { HttpParams } from "@angular/common/http";
import { ICompanyValidatorEmail } from "src/app/Models/Interface/Client/Validators/email";
import { ICompanyValidatorName } from "src/app/Models/Interface/Client/Validators/name";

@Injectable({
  providedIn: "root",
})
export class ValidateClientService {
  email = {} as ICompanyValidatorEmail;
  name = {} as ICompanyValidatorName;

  constructor(private dataService: DataService) {}

  validateCompanyEmail(): Observable<boolean> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("emailAddress", this.email.emailAddress);
    return this.dataService.getWithParams(
      APIName.client.validateClient.email,
      params
    );
  }

  validateCompanyName(): Observable<boolean> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("companyName", this.name.companyName);
    return this.dataService.getWithParams(
      APIName.client.validateClient.name,
      params
    );
  }

  validateUserEmail(userId?: number): Observable<boolean> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("emailAddress", this.email.emailAddress);
    if (userId) {
      params = params.append("userId", userId);
    }
    return this.dataService.getWithParams(
      APIName.client.validateClient.userEmail,
      params
    );
  }
}
